import { render, staticRenderFns } from "./DubaTips.vue?vue&type=template&id=1632137a&scoped=true&"
import script from "./DubaTips.vue?vue&type=script&lang=js&"
export * from "./DubaTips.vue?vue&type=script&lang=js&"
import style0 from "./DubaTips.vue?vue&type=style&index=0&id=1632137a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632137a",
  null
  
)

export default component.exports